<!-- Wrapper -->
<div class="wrapper">

  <!-- Header -->
  <div class="header">

    <!-- Logo -->
    <div class="logo">
      <img class="logo-text"
           src="assets/images/logo/logo-text.svg">
      <img class="logo-text-on-dark"
           src="assets/images/logo/logo-text-on-dark.svg">
      <img class="logo-base"
           src="assets/images/logo/logo.svg">
    </div>

    <!-- Spacer -->
    <div class="spacer"></div>

    <!-- User -->
    <user></user>

  </div>

  <!-- Content -->
  <div class="content">

    <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
         it won't register the changes on the layout and won't update the view. -->
    <router-outlet *ngIf="true"></router-outlet>
    <ngx-loader [fullScreen]="true" name="ball-atom"></ngx-loader>

  </div>

  <!-- Footer -->
  <div class="footer">
    <app-footer></app-footer>
  </div>

</div>
